import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './core/components/login/login.component';
import { ReloadDataComponent } from './core/components/reload-data/reload-data.component';
import { RouterPathConfig } from './core/constants/router-path.config';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { AuthorizedGuardRolesService } from './core/guards/authorized-guard-roles.service';
import { HomeAuthGuardService } from './core/guards/home-guard.service';
import { NotAthorizedPageComponent } from './shared/components/notAthorizedPage/notAthorizedPage/not-athorized-page.component';
import { TuwaiqLayoutComponent } from './tuwaiq-layout/tuwaiq-layout.component';

const routes: Routes = [
    { path: '', redirectTo: RouterPathConfig.HOME_PATH, pathMatch: 'prefix' },
    { path: 'reload-data', component: ReloadDataComponent },
    {
        path: RouterPathConfig.HOME_PATH,
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
        canActivate: [HomeAuthGuardService]
    },
    {
        path: RouterPathConfig.serviceCatalog,
        canActivate: [AuthorizedGuardRolesService],
        loadChildren: () => import('./serviceCatalog/serviceCatalog.module').then(m => m.ServiceCatalogModule)
    },

    {
        path: RouterPathConfig.services,
        canActivate: [AuthorizedGuardRolesService],
        loadChildren: () => import('./service/service.module').then(m => m.ServiceModule)
    },

    {
        path: RouterPathConfig.STRATEGY,
        canActivate: [AuthorizedGuardRolesService],
        loadChildren: () => import('./strategy/strategy.module').then(m => m.StrategyModule)
    },
    {
        path: RouterPathConfig.TICKETING,
        canActivate: [AuthorizedGuardRolesService],
        loadChildren: () => import('./ticketing/ticketing-view.module').then(m => m.TicketingViewModule)
    },
    {
        path: RouterPathConfig.MESSAGECENTER,
        canActivate: [AuthorizedGuardRolesService],
        loadChildren: () => import('./message-center/message-center.module').then(m => m.MessageCenterModule)
    },
    {
        path: RouterPathConfig.EMPOLYEE_MANAGEMENT_STATUS,
        canActivate: [AuthorizedGuardRolesService],
        loadChildren: () => import('./empolyee-management-status/empolyeeManagementStatus.module').then(m => m.EmpolyeeMangmentStatusModule)
    },
    {
        path: RouterPathConfig.CLIENT_MANAGEMENT_USERS,
        canActivate: [AuthorizedGuardRolesService],
        loadChildren: () => import('./client-management-users/client-management-users.component.module').then(m => m.ClientManagementUsersModule)
    },
    {
        path: RouterPathConfig.CALL_CENTER_CLIENT_MANAGEMENT,
        canActivate: [AuthorizedGuardRolesService],
        loadChildren: () => import('./call-center-client-management/call-center-client-management.module').then(m => m.CallCenterClientManagementModule)
    },
    { path: 'NotAthorizedPageComponent', component: NotAthorizedPageComponent },

    {
        path: '',
        component: TuwaiqLayoutComponent,
        children: [
            { path: RouterPathConfig.LOGIN_PATH, component: LoginComponent, canActivate: [AuthGuardService] },
            {
                path: RouterPathConfig.DATA_MANAGEMENT,
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => {
                    return (
                        import('./data-management/data-management.module').then(m => m.DataManagementModule),
                        import('./ticketing-module/ticketing-module.module').then(m => m.TicketingmoduleModule)
                    );
                }
            },

            {
                path: ':userPath/dashboard',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
                // canActivate: [DashboardAuthGuardService]
            },
            {
                path: ':userPath/callRecordDashboard',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./call-record-dashboard/call-record-dashboard.module').then(m => m.CallRecordDashboardModule)
            },
            {
                path: ':userPath/callRecord',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./call-record-management/call-record.module').then(m => m.CallRecordModule)
            },
            {
                path: ':userPath/:requestPath/create-record',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./call-record-management/component/call-record-create/create-record.module').then(m => m.CreateCallRecordModule)
            },
            {
                path: ':userPath/:requestPath/view-record',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () =>
                    import('./call-record-management/component/call-record-view-update/update-view-record.module').then(m => m.UpdateViewCallRecordModule)
            },
            {
                path: 'admin',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
                // canActivate: [AuthGuardService, AdminAuthGuardService]
            },
            {
                path: 'manager',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
                // canActivate: [AuthGuardService, ManagerAuthGuardService]
            },
            {
                path: 'employee',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./employee/employee.module').then(m => m.EmployeeModule)
                // canActivate: [AuthGuardService, EmployeeAuthGuardService]
            },
            {
                path: 'requester',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./requester/requester.module').then(m => m.RequesterModule)
                // canActivate: [AuthGuardService, RequesterAuthGuardService]
            },
            {
                path: 'account-manager',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./account-manager/account-manager.module').then(m => m.AccountManagerModule)
                // canActivate: [AuthGuardService, RequesterAuthGuardService]
            },
            {
                path: ':userPath/:requestPath/request',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./view-request/view-request.module').then(m => m.ViewRequestModule)
            },
            {
                path: ':userPath/:requestPath/create-request',
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
                // canActivate: [CreateRequestAuthGuardService]
            },
            {
                path: RouterPathConfig.FILE_MANAGEMENT,
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => {
                    return import('./file-management/file-management.module').then(m => m.FileManagementModule);
                }
            },
            {
                path: RouterPathConfig.PERIODIC_REVIEW,
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./periodic-review/periodic-review.module').then(m => m.PeriodicReviewModule)
            },
            {
                path: RouterPathConfig.DELEGATION,
                canActivate: [AuthorizedGuardRolesService],
                loadChildren: () => import('./delegation/delegation.module').then(m => m.DelegationModule)
            }
        ]
    },
    { path: '**', redirectTo: RouterPathConfig.HOME_PATH, pathMatch: 'prefix' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation: 'enabledBlocking'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
